import React from "react";
import { Grid, Typography, Hidden, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import ArrowDownward from "@material-ui/icons/ArrowDownward";

const useStyles = makeStyles((theme) => ({
  statsWrapper: {
    display: "flex",
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    backgroundColor: "#fff",
    borderRadius: 12,
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
  },
  statCardItem: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: theme.spacing(1),
    flex: 1,
  },
  statCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    textAlign: "center",
    padding: theme.spacing(2),
  },
  statLabel: {
    fontSize: "14px",
    fontWeight: 900,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    marginBottom: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  statValue: {
    fontSize: "1.5rem",
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    color: theme.palette.text.primary,
  },
  statDivider: {
    width: 1,
    backgroundColor: theme.palette.divider,
    margin: theme.spacing(1, 0),
  },
  trendContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: theme.spacing(1),
    height: 20, // Fixed height to prevent misalignment
  },
  trendText: {
    marginLeft: theme.spacing(0.5),
    fontSize: "12px",
    lineHeight: 1.2, // Ensures consistent line height
    whiteSpace: "nowrap", // Prevents text wrapping
  },
}));

const TrendIndicator = ({ value }) => {
  const isPositive = value > 0;
  const icon = isPositive ? (
    <ArrowUpward style={{ fontSize: "14px" }} />
  ) : (
    <ArrowDownward style={{ fontSize: "14px" }} />
  );

  return (
    <div
      style={{
        color: isPositive ? "#4caf50" : "#f44336",
        display: "flex",
        alignItems: "center",
      }}
    >
      {icon}
    </div>
  );
};

const Stats = ({ stats }) => {
  const classes = useStyles();

  const statItems = [
    {
      label: "Active Users",
      value: stats.weeklyActive,
      trend: 0,
    },
    { label: "Internal Users", value: stats.internal, trend: 0 },
    { label: "External Users", value: stats.external, trend: 0 },
    { label: "Total Users", value: stats.totalUsers, trend: 0 },
  ];

  return (
    <Paper className={classes.statsWrapper}>
      {statItems.map((stat, index) => (
        <React.Fragment key={index}>
          <div className={classes.statCardItem}>
            <div className={classes.statCard}>
              <Typography variant="h6" className={classes.statLabel}>
                {stat.label}
              </Typography>
              <Typography variant="h4" className={classes.statValue}>
                {stat.value.toLocaleString()}
              </Typography>
              {/* <div className={classes.trendContainer}>
              <TrendIndicator value={stat.trend} />
              <Typography variant="caption" className={classes.trendText}>
                  {Math.abs(stat.trend)}%{" "}
                  {stat.trend > 0 ? "increase" : "decrease"} from last month
                </Typography>
              </div> */}
            </div>
          </div>
          {index < statItems.length - 1 && (
            <Hidden xsDown>
              <div className={classes.statDivider} />
            </Hidden>
          )}
        </React.Fragment>
      ))}
    </Paper>
  );
};

export default Stats;
